import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../i18n/LanguageContext';
import '../../styles/layout.css';

const languageOptions = [
  { code: 'zh-TW', label: '中(繁)' },
  { code: 'zh-CN', label: '中(简)' },
  { code: 'en', label: 'EN' },
];

const Header = () => {
  const { user, loading, signInWithGoogle, signOut } = useAuth();
  const { lang, setLang, t } = useLanguage();
  const { pathname } = useLocation();
  const isSttActive = pathname.startsWith('/lecture');
  const isFaqActive = pathname.startsWith('/lecture/faq');

  return (
    <header className="app-header">
      <div className="header-left">
        <NavLink to="/lecture/upload" className="brand">
          <div className="brand-icon" aria-hidden="true">
            AI
          </div>
          <div className="brand-text">
            <div className="brand-title">{t('appName')}</div>
            <div className="brand-subtitle">{t('appTagline')}</div>
          </div>
        </NavLink>
      </div>

      <div className="header-middle">
        <div className="nav-links product-nav">
          <a
            className="nav-link"
            href="https://chat.aittsservice.online"
            target="_blank"
            rel="noreferrer"
          >
            {t('navChat')}
          </a>
          <a
            className="nav-link"
            href="https://tts.aittsservice.online"
            target="_blank"
            rel="noreferrer"
          >
            {t('navTts')}
          </a>
          <NavLink
            to="/lecture/upload"
            className={() => `nav-link${isSttActive ? ' active' : ''}`}
          >
            {t('navStt')}
          </NavLink>
        </div>

        <div className="nav-links app-nav">
          <NavLink
            to="/lecture/upload"
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            {t('navUpload')}
          </NavLink>
          <NavLink
            to="/lecture/status"
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            {t('navStatus')}
          </NavLink>
          <NavLink
            to="/lecture/faq"
            className={() => `nav-link${isFaqActive ? ' active' : ''}`}
          >
            {t('navFaq')}
          </NavLink>
          <NavLink
            to="/lecture/pricing"
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            {t('navPricing')}
          </NavLink>
        </div>
      </div>

      <div className="header-actions">
        <div className="language-toggle" aria-label="Language switcher">
          {languageOptions.map((option) => (
            <button
              key={option.code}
              type="button"
              className={`lang-button${lang === option.code ? ' active' : ''}`}
              onClick={() => setLang(option.code)}
            >
              {option.label}
            </button>
          ))}
        </div>

        {user && (
          <>
            <div className="user-chip" title={user.email}>
              {t('signedInAs')} {user.name || user.email}
            </div>
            <button
              type="button"
              className="secondary-button"
              onClick={signOut}
            >
              {t('signOut')}
            </button>
          </>
        )}

        {!user && !loading && (
          <button
            type="button"
            className="primary-button"
            onClick={signInWithGoogle}
          >
            {t('signInWithGoogle')}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
